import PubSub from "underpub-js";

var MapPoiList = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-MapPoiList',
	};

	$.extend(true, this.options, options);

};

MapPoiList.prototype.init = function() {

	var self = this;

};

export default MapPoiList;
